import React from 'react';
import PropTypes from 'prop-types';
import TabPanel from './tab_panel';

// Virtual container for the tab content area.
// Exactly one of the child tab content areas is rendered.
export default function TabPanels({
  children,
  activeName,
  a11yKeyboard,
  a11yRolesErb,
}) {
  const clonedChildren = React.Children.map(children, (child) =>
    React.cloneElement(child, { activeName, a11yKeyboard, a11yRolesErb }),
  );
  return <div>{clonedChildren}</div>;
}

TabPanels.propTypes = {
  activeName: PropTypes.string,
  children: PropTypes.arrayOf(TabPanel).isRequired,
  a11yKeyboard: PropTypes.bool,
  a11yRolesErb: PropTypes.bool,
};

TabPanels.defaultProps = {
  activeName: null,
  a11yKeyboard: false,
  a11yRolesErb: false,
};
